import { MantineThemeOverride } from '@mantine/core';

export type KbdTheme = NonNullable<MantineThemeOverride['components']>['Kbd'];

export const Kbd: KbdTheme = {
  // todo: define
};
